import { ReactNode } from 'react';
import EmptyStateWrapper from './EmptyStateWrapper';
import NoResultsEmptyState from './NoResultsEmptyState';

interface ListEmptyStateProps {
  hasActiveFilters: boolean;
  children: ReactNode;
  noResultsTestId?: string;
}

const ListEmptyState = ({ hasActiveFilters, children, noResultsTestId }: ListEmptyStateProps) => {
  if (hasActiveFilters) {
    return <NoResultsEmptyState testId={noResultsTestId} />;
  }

  return <EmptyStateWrapper>{children}</EmptyStateWrapper>;
};

export default ListEmptyState;
